import { render, staticRenderFns } from "./RealFRQView.vue?vue&type=template&id=21aaf588&"
import script from "./RealFRQView.vue?vue&type=script&lang=js&"
export * from "./RealFRQView.vue?vue&type=script&lang=js&"
import style0 from "./RealFRQView.vue?vue&type=style&index=0&id=21aaf588&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports